<div class="container-fluid">
  <h5 class="text-center">Solicitação de bens</h5>
  <div class="flex-row d-md-flex p-6"> 
    <div class="col-md">
      <h5 class="card-title text-center">Bens</h5>
      <div class="card">
        <div class="card-body">
          
          <div class="input-group input-group-sm mb-3">
            <i class="bi bi-search" aria-hidden="true"></i>
            <input class="form-control form-control-sm ml-3 w-75" type="text" 
            placeholder="Procurar"aria-label="Search">
            
          </div>
          <div class="list-group list-group-flush list-group-item-success">
            
            <button type="button" class="list-group-item list-group-item-action 
            list-group-item-success">Dapibus ac facilisis in</button>
            <button type="button" class="list-group-item list-group-item-action 
            list-group-item-success">Morbi leo risus</button>
            <button type="button" class="list-group-item list-group-item-action 
            list-group-item-success">Porta ac consectetur ac</button>
          </div>
        </div>
      </div>
    </div>
    &nbsp;
    &nbsp;
    &nbsp;
  <div class="row align-self-center">
    <div class="col-sm-6">
      
      <button type="button" class="btn btn-success"><i class="bi bi-caret-right-fill"></i></button>
      <button type="button" class="btn btn-success"><i class="bi bi-caret-left-fill"></i></button>
    </div>
  </div>
  <div class="row">
    
  </div>
  <div class="col-md">
    <h5 class="card-title text-center">Meus Bens</h5>
    <div class="card">
      <div class="card-body">
        <div class="list-group list-group-flush list-group-item-success">
          
          <button type="button" class="list-group-item list-group-item-action 
          list-group-item-success">Dapibus ac facilisis in</button>
          <button type="button" class="list-group-item list-group-item-action 
          list-group-item-success">Morbi leo risus</button>
          <button type="button" class="list-group-item list-group-item-action 
          list-group-item-success">Porta ac consectetur ac</button>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
